import { createFileRoute, redirect } from '@tanstack/react-router'

import { Permission } from '@/lib/permissions'

export const Route = createFileRoute('/_dashboard/site/$id/medical-fluid/$floorId/')({
  beforeLoad({ context }) {
    if (!context.user?.hasPermission(Permission.EDIT_FLOOR_PLAN)) {
      throw redirect({ to: '/403' })
    }
  },
})
